import React from 'react';

import { FooterContainer } from './styledComponents';

const Footer = ({ children, customStyle }) => (
  <FooterContainer style={customStyle}>{children}</FooterContainer>
);

export default Footer;
